// extracted by mini-css-extract-plugin
export default {"NotificationBoxes":"NotificationBoxes_NotificationBoxes__M9DsS","WarningText":"NotificationBoxes_WarningText__GYb+p"};